export const PERMISSION_KEYS = {
  EXPORT_ALL: 'export-all',
  VIEW_SALES: 'view-sales',
} as const
